// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"3762592a726f479e1aa1","293":"f659746bf2204376d1e7","518":"9661266111f600b7f173","779":"313381bcf542b90300a4"}[chunkId] + ".js";
};